import React from "react";

/**
 * A wrapper around React.lazy that catches ChunkLoadErrors (which happen when
 * new deployments overwrite/remove chunk files) and reloads the page to get
 * the latest version of the app.
 */
export function safeLazy(importFn) {
    return React.lazy(() =>
        importFn().catch((error) => {
            const isChunkLoadFailed =
                error.name === "ChunkLoadError" ||
                /loading\s+chunk\s+/i.test(error.message) ||
                error.message?.includes("dynamically imported module");
            
            if (isChunkLoadFailed) {
                console.warn("Chunk loading failed. Reloading the page to retrieve the latest version...", error);
                window.location.reload();
            }
            throw error;
        })
    );
}
